// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-action-bar{position:fixed;bottom:0;left:0;right:0}.add-wrapper{border:2px dashed #ddd!important;background:#f5f5f5}", ""]);
// Exports
module.exports = exports;
